import type { AppThunk } from "@Store/index";
import { getBlogLanguageFromPath } from "@Pages/Blog/utils/blogLanguage";
import config from "@Config/index";
import loadBlogData from "@Pages/Blog/data/loadData";
import { fetchNewBlogPostData } from "./newBlogPostReducer";

/**
 * SSR loadData for the new blog post page (/blog/post/:slug and
 * /drafts-blog/post/:slug). Resolves the regional blog language from the path
 * so language-prefixed routes fetch from the correct collection.
 */
const loadData = (props: any): AppThunk[] => {
  const path = __SERVER__ ? props?.req?.path : window.location.pathname;
  if (config.IS_CHINA_APP) return loadBlogData(props);
  const lang = getBlogLanguageFromPath(path);
  return [fetchNewBlogPostData(props, lang)];
};

export default loadData;
